import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AuthenticationService } from "../services/authentication.service";
import { StorageService } from "../../storage.service";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    private storage: StorageService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.authenticationService.refreshSession().pipe(
      map((isAuthenticated) => {
        if (isAuthenticated) {
          return true;
        }

        this.storage.setItem("openLoginDialogue", "true");
        this.router.navigate(["/"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }),
    );
  }
}
